import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AuthGate from '../../containers/auth/AuthGate';
import './NextGenSidebarMenu.scss';
import NextGenSidebarGroup from './NextGenSidebarGroup';
import { connect } from 'react-redux';
import { NAV_OPEN_STAGES, closeNav, openNavMax, openNavMin } from '../../actions/actions_navigation';
import { Box, IconButton } from '@chakra-ui/react';
import { ReactComponent as SeparateIconSVG } from '../../assets/separate.svg';
import { iff } from '../../helpers';
import withRouter from '@/components/utilities/withRouter';
import { getTenantFromDomain } from '../../utils';

const NAV_OPEN_DELAY_MS = 500;
const tenant = getTenantFromDomain();
const isCfcTenant = tenant.includes('cfc');
// const navBackground = isCfcTenant ? '#0F1B48' : 'var(--colors-nav-main)'

const hostname = window.location.hostname.toLowerCase();

const isLocal = hostname === 'localhost';
const isDev = hostname.startsWith('dev.');
const isUat = hostname.startsWith('uat.');
const isProd = !isLocal && !isDev && !isUat;

// Same color for local / dev / uat
const NON_PROD_COLOR = '#6e3907ff';

// Prod colors per tenant
const PROD_COLOR_BOAB = 'var(--colors-nav-main)';
const PROD_COLOR_CFC = '#0F1B48';

const navBackground = isProd
  ? (isCfcTenant ? PROD_COLOR_CFC : PROD_COLOR_BOAB)
  : NON_PROD_COLOR;

const propTypes = {
  routeConfig: PropTypes.shape({
    groups: PropTypes.arrayOf(
      PropTypes.shape({
        authConfig: PropTypes.shape({
          // Define the specific shape of authConfig here
          isAuthenticated: PropTypes.bool,
          userRole: PropTypes.string,
        }),
      })
    ),
  }),
  navigation: PropTypes.shape({
    openStatus: PropTypes.oneOf(Object.values(NAV_OPEN_STAGES)).isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

const NextGenSidebarMenu = ({ routeConfig, dispatch, navigation }) => {
  const [timer, setTimer] = useState(null);
  // const breakpoints = useBreakpoint();

  // const [isMobileScreen] = useMediaQuery(`(max-width: ${get(breakpoints, 'asObject.lg', '62em')})`);
  const isMobileScreen = false;

  const { openStatus } = navigation;

  const checkIfOpen = () => {
    if (isMobileScreen) {
      return openStatus === NAV_OPEN_STAGES.max_opened;
    }

    return openStatus === NAV_OPEN_STAGES.max_opened || openStatus === NAV_OPEN_STAGES.min_opened;
  };

  return (
    <Box
      className="next-gen-nav"
    >
      <Box
        className={`nav-ribbon ${checkIfOpen() ? 'open' : 'closed'}`}
        style={{ backgroundColor: navBackground }}
        {...(isMobileScreen &&
          openStatus === NAV_OPEN_STAGES.closed && {
            width: 0,
            paddingX: '0px !important',
          })}
        onMouseLeave={() => {
          if (isMobileScreen) return;
          dispatch(closeNav());
          document.body.classList.remove('noscroll');
          if (timer) {
            clearTimeout(timer);
          }
        }}
      >
        {routeConfig.groups.map(group => {
          const isFMG = tenant.includes('fmg');
          const filteredGroup = {
            ...group,
            ...(Array.isArray(group.children) && {
              children: group.children.filter(child => {
                const isUSInvoicing =
                  child?.routeConfig?.path === '/finance-invoicing/us-invoicing' || child?.name === 'US Invoicing';
                return isFMG ? true : !isUSInvoicing;
              }),
            }),
          };
          return (
            <AuthGate {...filteredGroup.authConfig} key={filteredGroup.name}>
              <NextGenSidebarGroup group={filteredGroup} open={checkIfOpen()} isMobile={isMobileScreen} />
            </AuthGate>
          );
        })}
        <div style={{ flex: 1 }} />
      </Box>
      {isMobileScreen && (
        <IconButton
          position="fixed"
          background="nav.main"
          _hover={{
            background: 'nav.main',
          }}
          minWidth="28px"
          height="28px"
          left={iff(
            openStatus === NAV_OPEN_STAGES.closed,
            '-28px',
            openStatus === NAV_OPEN_STAGES.max_opened ? '284px' : '62px'
          )}
          zIndex="100"
          transition="left .1s linear"
          borderWidth="1px"
          onClick={() => {
            if (openStatus === NAV_OPEN_STAGES.max_opened) dispatch(openNavMin());
            else dispatch(openNavMax());
          }}
        >
          <SeparateIconSVG />
        </IconButton>
      )}
    </Box>
  );
};

NextGenSidebarMenu.propTypes = propTypes;

const mapStateToProps = state => {
  return {
    navigation: state.navigation,
  };
};

export default connect(mapStateToProps)(withRouter(NextGenSidebarMenu));
